import { render, staticRenderFns } from "./DependentInclusionRulesModal.vue?vue&type=template&id=0802adc4"
import script from "./DependentInclusionRulesModal.vue?vue&type=script&lang=js"
export * from "./DependentInclusionRulesModal.vue?vue&type=script&lang=js"
import style0 from "./DependentInclusionRulesModal.vue?vue&type=style&index=0&id=0802adc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports